"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InneditProvider = void 0;

var nanoid_1 = require("nanoid");

var react_1 = __importStar(require("react"));

var index_1 = require("../index");

var defaultState = {
  addToCart: function addToCart(item) {},
  addToDemande: function addToDemande(item) {},
  addToReserved: function addToReserved(item) {},
  cart: [],
  clearCart: function clearCart() {},
  clearDemande: function clearDemande() {},
  clearReserved: function clearReserved() {},
  dark: false,
  decrementCartItem: function decrementCartItem() {},
  demande: [],
  incrementCartItem: function incrementCartItem() {},
  produits: [],
  removeCartItem: function removeCartItem(itemId) {},
  removeDemandeItem: function removeDemandeItem(itemId) {},
  removeReservedItem: function removeReservedItem(itemId) {},
  reserved: [],
  setProduits: function setProduits(produits) {},
  toggleDark: function toggleDark() {},
  user: {
    id: (0, nanoid_1.nanoid)()
  }
};
var InneditContext = react_1.default.createContext(defaultState);

var supportsDarkMode = function supportsDarkMode() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

var InneditProvider = function InneditProvider(_ref) {
  var children = _ref.children;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      save = _ref3[0],
      setSave = _ref3[1];

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      dark = _ref5[0],
      setDark = _ref5[1];

  var _ref6 = (0, react_1.useState)([]),
      _ref7 = _slicedToArray(_ref6, 2),
      cart = _ref7[0],
      setCart = _ref7[1];

  var _ref8 = (0, react_1.useState)([]),
      _ref9 = _slicedToArray(_ref8, 2),
      demande = _ref9[0],
      setDemande = _ref9[1];

  var _ref10 = (0, react_1.useState)([]),
      _ref11 = _slicedToArray(_ref10, 2),
      produits = _ref11[0],
      setProduits = _ref11[1];

  var _ref12 = (0, react_1.useState)([]),
      _ref13 = _slicedToArray(_ref12, 2),
      reserved = _ref13[0],
      setReserved = _ref13[1];

  var _ref14 = (0, react_1.useState)({
    id: (0, nanoid_1.nanoid)()
  }),
      _ref15 = _slicedToArray(_ref14, 2),
      user = _ref15[0],
      setUser = _ref15[1];

  (0, react_1.useEffect)(function () {
    var saveToLocalStorage = function saveToLocalStorage() {
      localStorage.setItem('innedit.demande', JSON.stringify(demande));
      localStorage.setItem('innedit.reserved', JSON.stringify(reserved));
      localStorage.setItem('innedit.cart', JSON.stringify(cart));
      localStorage.setItem('innedit.user', JSON.stringify(user));
    };

    if (save) {
      saveToLocalStorage();
      setSave(false);
    }
  }, [cart, demande, reserved, save, user]);

  var toggleDark = function toggleDark() {
    localStorage.setItem('innedit.dark', JSON.stringify(!dark));
    setDark(!dark);
  };

  var addToDemande = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
      var index, ligne, _demande$splice, _demande$splice2, produit;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              index = demande.findIndex(function (ligne) {
                return ligne.id === item.id;
              });

              if (index >= 0) {
                _demande$splice = demande.splice(index, 1);
                _demande$splice2 = _slicedToArray(_demande$splice, 1);
                ligne = _demande$splice2[0];
              } else {
                ligne = _objectSpread(_objectSpread({}, item), {}, {
                  quantity: 0
                });
              }

              _context.next = 4;
              return index_1.ProduitModel.get(item.id);

            case 4:
              produit = _context.sent;
              ligne.quantity = index_1.ProduitModel.calculNewQuantity(ligne.quantity + Number(item.quantity), ligne.quantity, produit);
              demande.push(ligne);
              setDemande(_toConsumableArray(demande));
              setSave(true);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addToDemande(_x) {
      return _ref16.apply(this, arguments);
    };
  }();

  var removeDemandeItem = function removeDemandeItem(itemId) {
    var index = demande.findIndex(function (ligne) {
      return ligne.id === itemId;
    });

    if (index >= 0) {
      demande.splice(index, 1);
    }

    setDemande(_toConsumableArray(demande));
    setSave(true);
  };

  var clearDemande = function clearDemande() {
    setDemande([]);
    setSave(true);
  };

  var addToReserved = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
      var index, ligne, _reserved$splice, _reserved$splice2, produit;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              index = reserved.findIndex(function (ligne) {
                return ligne.id === item.id;
              });

              if (index >= 0) {
                _reserved$splice = reserved.splice(index, 1);
                _reserved$splice2 = _slicedToArray(_reserved$splice, 1);
                ligne = _reserved$splice2[0];
              } else {
                ligne = _objectSpread(_objectSpread({}, item), {}, {
                  quantity: 0
                });
              }

              _context2.next = 4;
              return index_1.ProduitModel.get(item.id);

            case 4:
              produit = _context2.sent;
              ligne.quantity = index_1.ProduitModel.calculNewQuantity(ligne.quantity + Number(item.quantity), ligne.quantity, produit);
              reserved.push(ligne);
              setReserved(_toConsumableArray(reserved));
              setSave(true);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function addToReserved(_x2) {
      return _ref17.apply(this, arguments);
    };
  }();

  var removeReservedItem = function removeReservedItem(itemId) {
    var index = reserved.findIndex(function (ligne) {
      return ligne.id === itemId;
    });

    if (index >= 0) {
      reserved.splice(index, 1);
    }

    setReserved(_toConsumableArray(reserved));
    setSave(true);
  };

  var clearReserved = function clearReserved() {
    setReserved([]);
    setSave(true);
  };

  var addToCart = /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
      var index, ligne, _cart$splice, _cart$splice2, produit;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              index = cart.findIndex(function (ligne) {
                return ligne.id === item.id;
              });

              if (index >= 0) {
                _cart$splice = cart.splice(index, 1);
                _cart$splice2 = _slicedToArray(_cart$splice, 1);
                ligne = _cart$splice2[0];
              } else {
                ligne = _objectSpread(_objectSpread({}, item), {}, {
                  quantity: 0
                });
              }

              _context3.next = 4;
              return index_1.ProduitModel.get(item.id);

            case 4:
              produit = _context3.sent;
              ligne.quantity = index_1.ProduitModel.calculNewQuantity(ligne.quantity + Number(item.quantity), ligne.quantity, produit);
              cart.push(ligne);
              setCart(_toConsumableArray(cart));
              setSave(true);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function addToCart(_x3) {
      return _ref18.apply(this, arguments);
    };
  }();

  var incrementCartItem = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(itemId) {
      var index, item, produit;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              index = cart.findIndex(function (ligne) {
                return itemId === ligne.id;
              });

              if (!(index >= 0)) {
                _context4.next = 7;
                break;
              }

              item = cart[index];
              _context4.next = 5;
              return index_1.ProduitModel.get(item.id);

            case 5:
              produit = _context4.sent;
              cart[index].quantity = index_1.ProduitModel.calculNewQuantity(cart[index].quantity + 1, cart[index].quantity, produit);

            case 7:
              setCart(_toConsumableArray(cart));
              setSave(true);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function incrementCartItem(_x4) {
      return _ref19.apply(this, arguments);
    };
  }();

  var decrementCartItem = /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(itemId) {
      var index, item, produit;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              index = cart.findIndex(function (ligne) {
                return ligne.id === itemId;
              });

              if (!(index >= 0)) {
                _context5.next = 7;
                break;
              }

              item = cart[index];
              _context5.next = 5;
              return index_1.ProduitModel.get(item.id);

            case 5:
              produit = _context5.sent;
              cart[index].quantity = index_1.ProduitModel.calculNewQuantity(cart[index].quantity - 1, cart[index].quantity, produit);

            case 7:
              setCart(_toConsumableArray(cart));
              setSave(true);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function decrementCartItem(_x5) {
      return _ref20.apply(this, arguments);
    };
  }();

  var removeCartItem = function removeCartItem(itemId) {
    var index = cart.findIndex(function (ligne) {
      return ligne.id === itemId;
    });

    if (index >= 0) {
      cart.splice(index, 1);
    }

    setCart(_toConsumableArray(cart));
    setSave(true);
  };

  var clearCart = function clearCart() {
    setCart([]);
    setSave(true);
  };

  (0, react_1.useEffect)(function () {
    var lsDark = JSON.parse(String(localStorage.getItem('innedit.dark')));

    if (lsDark) {
      setDark(lsDark);
    } else if (supportsDarkMode()) {
      setDark(true);
    }

    var lsUser = JSON.parse(String(localStorage.getItem('innedit.user')));

    if (lsUser) {
      setUser(lsUser);
    }

    var lsDemande = JSON.parse(String(localStorage.getItem('innedit.demande')));

    if (lsDemande) {
      setDemande(lsDemande);
    }

    var lsReserved = JSON.parse(String(localStorage.getItem('innedit.reserved')));

    if (lsReserved) {
      setReserved(lsReserved);
    }

    var lsCart = JSON.parse(String(localStorage.getItem('innedit.cart')));

    if (lsCart) {
      setCart(lsCart);
    }
  }, []);
  return react_1.default.createElement(InneditContext.Provider, {
    value: {
      addToCart: addToCart,
      addToDemande: addToDemande,
      addToReserved: addToReserved,
      cart: cart,
      clearCart: clearCart,
      clearDemande: clearDemande,
      clearReserved: clearReserved,
      dark: dark,
      decrementCartItem: decrementCartItem,
      demande: demande,
      incrementCartItem: incrementCartItem,
      produits: produits,
      removeCartItem: removeCartItem,
      removeDemandeItem: removeDemandeItem,
      removeReservedItem: removeReservedItem,
      reserved: reserved,
      setProduits: setProduits,
      toggleDark: toggleDark,
      user: user
    }
  }, children);
};

exports.InneditProvider = InneditProvider;
exports.default = InneditContext;